export const ARTICLE_SECTION_TYPES = {
  FULL_IMAGE: 'FullImageSection',
  TEXT: 'TextSection',
};

export default ARTICLE_SECTION_TYPES;
